module.exports = __webpack_public_path__ + "static/media/minimum.2f8c01b9.svg";